// const BASE_URL = "http://localhost:8084";

// const BASE_URL = "https://31.97.206.32:8084";

const BASE_URL = "https://office.shreeshtech.com";

// const BASE_URL = "https://demo.shreeshtech.com"

// const SUB_URL = "/api/v1";

const SUB_URL = "/api/v1";
const mainurl = `${BASE_URL}${SUB_URL}`;
const letter = `${mainurl}/letter`

const digitalSign = 'letter/digitalsign';
const HRM_URL = '/api/v1/hrm/';
const TASK = 'task';
const ROOM_URL = '/room';
export const ENDPOINT = {

  base: BASE_URL,
  enquiries: `${BASE_URL}${SUB_URL}/enquiries`,
  activeEnquiries: `${BASE_URL}${SUB_URL}/enquiries/active`,
  roles: `${BASE_URL}${SUB_URL}/employee/roles`,
  Users: `${BASE_URL}${SUB_URL}/users`,
  lastUsers: `${BASE_URL}${SUB_URL}/users/last`,
  customer: `${BASE_URL}${SUB_URL}/customer`,
  services: `${BASE_URL}${SUB_URL}/service`,
  serviceTypes: `${BASE_URL}${SUB_URL}/service/type`,
  products: `${BASE_URL}${SUB_URL}/service/product`,
  products_cat: `${BASE_URL}${SUB_URL}/service/product-cat`,
  eqstatus: `${BASE_URL}${SUB_URL}/status`,
  eqcurrency: `${BASE_URL}${SUB_URL}/status/currency`,
  auth_vaildation: `${BASE_URL}${SUB_URL}/auth`,
  login: `${mainurl}/login`,
  lopass: `${mainurl}/lopass`,
  createpass: `${mainurl}/createpass`,
  bank: `${mainurl}/bank`,
  Head: `${letter}/head`,
  footer: `${letter}/footer-org`,
  digitalSign: `${mainurl}/${digitalSign}/image`,
  deleteDgSignDb: `${mainurl}/${digitalSign}/db`,
  getAllDgSignDb: `${mainurl}/${digitalSign}`,
  TC: `${letter}/tc`,
  quotation: `${mainurl}/quotation`,
  quotationByUser: `${mainurl}/quotation/user`,
  Department: `${mainurl}/dpt`,
  Project: `${mainurl}/project`,
  Invoice: `${mainurl}/invoice`,
  Expense: `${mainurl}/expense`,
  UBType: `${mainurl}/expense/ub-type`,
  lastAddedPO: `${mainurl}/expense/po`,
  lastAddedBill: `${mainurl}/expense/bill`,
  poAddedBill: `${mainurl}/expense/po`,
  projectAddedBill: `${mainurl}/expense/project`,
  Vendors: `${mainurl}/vendor`,
  Payment: `${mainurl}/expense/payment`,
  BillPayment: `${mainurl}/expense/payment/bill`,
  ProjectPayment: `${mainurl}/expense/payment/project`,
  PoPayment: `${mainurl}/expense/payment/po`,
  Permission: `${BASE_URL}${HRM_URL}permissions`,
  Announce: `${BASE_URL}${ROOM_URL}announce`,
  reportByPayMode: `${BASE_URL}${SUB_URL}/report/finance`,

  Complaint: `${mainurl}/complaint`,

  leaveType: `${BASE_URL}${HRM_URL}leave/type`,
  leaveRequest: `${BASE_URL}${HRM_URL}leave/request`,

  timeline: `${mainurl}/${TASK}/timeline`,
  task: `${mainurl}/${TASK}`,

  employeedetailsleavetype: `${BASE_URL}${HRM_URL}employe/details/leavetype`,

  employeesalary: `${BASE_URL}${HRM_URL}employe/details/addsalary`,

  employeeUploadDetails: `${BASE_URL}${HRM_URL}upload/uploaddetails`,

  employeeofferletter: `${BASE_URL}${HRM_URL}employees/offerletter`,

  organizationlogo: `${BASE_URL}${SUB_URL}/logo/orglogo`,

  checkin: `${BASE_URL}${HRM_URL}checkin`,

  breaktype: `${BASE_URL}${HRM_URL}breaks`,

  employeesalaryissued: `${BASE_URL}${HRM_URL}salary`,

  Configuration: `${mainurl}/configuration`,

  AddEmployees: `${BASE_URL}${HRM_URL}add-employees`,

  SalesTargets: `${BASE_URL}${HRM_URL}sales-targets`,

  SalesTeams: `${BASE_URL}${HRM_URL}sales-teams`,

  Notifications: `${BASE_URL}${HRM_URL}notifications`,

  EmailConfig: `${BASE_URL}${HRM_URL}email-config`,

  Requirement: `${mainurl}/requirement`,

  Milestone: `${mainurl}/milestone`,

  ProjectTask: `${mainurl}/project-task`,

  Meeting: `${mainurl}/meeting`,

  Document: `${mainurl}/document`,
  Item: `${mainurl}/item`,

  Category: `${mainurl}/category`,

  Supplier: `${mainurl}/supplier`,
  PurchaseOrder: `${mainurl}/purchase-order`,
  GoodsReceipt: `${mainurl}/goods-receipt`,
  StockTransfer: `${mainurl}/stock-transfer`,
  Adjustment: `${mainurl}/adjustment`,
  StockLedger: `${mainurl}/stock-ledger`,

  StockCount: `${mainurl}/stock-count`,


};

